export enum KpiStatus
{
    OK = 0,
    Empty,
    AwaitingApproval
}
